module.exports = __webpack_public_path__ + "img/boiler-E-idle.51d8195c.png";